
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi/konfirmasi-data",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/konfirmasi-data.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi/konfirmasi-data"])
      });
    }
  